var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.infoBlockGray] = _vm.theme === 'gray', _class[_vm.$style.infoBlockWarning] = _vm.theme === 'warning', _class[_vm.$style.infoBlock] = true, _class)
  }, [!_vm.hideIcon ? _c('MottoIcon', {
    class: _vm.$style.infoLogo,
    attrs: {
      "name": "Info",
      "icon-color": _vm.iconColor
    }
  }) : _vm._e(), _c('p', {
    staticClass: "p2",
    class: [_vm.$style.infoText, _vm.bigText ? _vm.$style.bigText : '']
  }, [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }